import { IThunderboltEntry } from '@wix/editor-elements-types';

import {
  registerComponentTypeUiTypes,
  UiTypesRegistrationMap,
} from '../../registration/registration';

const UiTypes: UiTypesRegistrationMap = {
  '': () => [
    import('./viewer/Checkbox' /* webpackChunkName: "Checkbox" */),
    import('./viewer/Checkbox.controller' /* webpackChunkName: "Checkbox" */),
  ],
};

const entry: IThunderboltEntry = {
  loadComponent: registerComponentTypeUiTypes('Checkbox', UiTypes),
};

export default entry;
